import { Box } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Condition, Iteration } from 'Component/others';
import DataNotFound from 'Component/data-notfound';
import { useUserInfo } from 'Store/userInfo';
import useGetHostPromoList from 'Domain/host-stock-promo/useGetHostPromoList';
import CardPromo from 'View/host-stock-promo/component/card-promo';
import CardPromoSkeleton from 'View/host-stock-promo/component/skeleton/card-promo-skeleton';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import styles from './styles.module.css';

const Promo = () => {
  const { filterState, updateFilterState } = useHostStockPromoState();
  const { isLoadingUser } = useUserInfo();

  const { data: promoList, isFetching: isLoadingPromo } = useGetHostPromoList({ enabled: !isLoadingUser, params: filterState });

  const hasMoreData = promoList?.currentPage < promoList?.totalPage;
  const hasData = promoList?.promotions?.length > 0;
  const isLoadingState = (isLoadingPromo || isLoadingUser) && !hasData;

  const onLoadMore = () => {
    updateFilterState({ page: filterState.page + 1 });
  };

  return (
    <InfiniteScroll dataLength={promoList?.promotions?.length ?? 0} hasMore={hasMoreData} next={onLoadMore} scrollThreshold="90%">
      <Box className={styles['promo-host__container']} marginBottom={hasMoreData ? '50px' : '0px'} data-testid="promo">
        <Condition statement={!isLoadingState} fallback={<CardPromoSkeleton />}>
          <Condition
            statement={hasData}
            fallback={<DataNotFound background="var(--color-semantic-white)" height="calc(100vh - 320px)" fieldSearch={filterState.search} />}
          >
            <Iteration key={promoList?.id} items={promoList?.promotions} render={(item) => <CardPromo data={item} />} />
          </Condition>
        </Condition>
      </Box>
    </InfiniteScroll>
  );
};

export default Promo;
